import { Injectable } from '@angular/core';
import { ComparisonOperator } from '@common/enums';
import { DriveOdataItem } from '@common/models';
import { ODataPagedResult } from '@common/odata';
import { SharedOdataService } from '@common/services';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DriveTreeOdataService extends SharedOdataService<DriveOdataItem> {
  private readonly odataDriveItems = this.odataFactory.CreateService<any>('DriveItems');

  #dateTime: string = null;
  set dateTime(value: string) {
    this.#dateTime = value;
    this.updateCustomOptions({ key: 'dateTime', value }, !value);
  }

  get dateTime(): string {
    return this.#dateTime;
  }

  constructor() {
    super('DriveItems');
    this.setDefaultOdataOptions();
  }

  fetchItems(): Observable<ODataPagedResult<DriveOdataItem>> {
    return this.fetchData(this.odataDriveItems);
  }

  updateCustomOptions(options: { key: string; value?: any }, isDelete = false): void {
    const { key, value } = options || {};

    if (isDelete) {
      this.removeCustomQueryOption(key);
    } else {
      this.addCustomQueryOption(key, value);
    }
  }

  setDefaultOdataOptions(): void {
    this.page = 1;
    this.pageSize = 100;
    this.orderBy = 'Type asc, Name asc';
    this.filter = `Type ${ComparisonOperator.Eq} false`;
  }
}
